import { twMerge } from '@shared/themes';
import type { ComponentProps } from 'react';
import type { DreamPodConfig } from '../../constants';
import { DreamPod } from '../DreamPod';

type DreamPodWrapperProps = Omit<ComponentProps<typeof DreamPod>, 'image' | 'title' | 'description'> & {
  pod: DreamPodConfig;
  additionalClassName?: string;
};

/**
 * Wrapper component for DreamPod
 * @param pod - The complete DreamPodConfig object
 * @param additionalClassName - Optional additional CSS classes to merge with sizeClasses
 */
function DreamPodWrapper({ pod, additionalClassName, ...props }: DreamPodWrapperProps) {
  const { sizeClasses, ...podProps } = pod;
  const mergedClassName = twMerge(sizeClasses, additionalClassName);

  return <DreamPod {...podProps} className={mergedClassName} {...props} />;
}

export { DreamPodWrapper, type DreamPodWrapperProps };
